import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { professionalMayUseDesk } from "../../js/api/accountLifecycle";
import { useAuth } from "../../js/hooks/useAuth";

export default function RequireLifecycleActive({ children }) {
  const { session, logout } = useAuth();
  const location = useLocation();
  const blocked =
    Boolean(session?.userId) && session.role !== "admin" && !professionalMayUseDesk(session.userId);
  const allowAccount = location.pathname.startsWith("/account");

  useEffect(() => {
    if (blocked && !allowAccount) logout();
  }, [blocked, allowAccount, logout]);

  if (blocked && !allowAccount) {
    return <Navigate to={session?.role === "broker" ? "/broker/login" : "/agent/login"} replace />;
  }
  return children;
}
